import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import ResultPage from '@blade-sxp/data-mining/components/result-page.vue';
let default_1 = class default_1 extends Vue {
    imgList;
    param;
    loading;
    empty;
    isDate;
    emptyDefault = require('@blade-sxp/data-mining/assets/images/empty-img-default.svg');
    // isDate: boolean = true;
    default = true;
    isCheckedBg = false;
    changeList(val) {
        this.$router.push({
            name: 'result',
            query: { param: JSON.stringify(this.param), companionEntityId: val.documentId },
        });
    }
    handleCommand(command) {
        if (command === 'times') {
            // this.isDate = false;
            this.$emit('sort-times');
        }
        else if (command === 'date') {
            // this.isDate = true;
            this.$emit('sort-Date');
        }
    }
};
__decorate([
    Prop()
], default_1.prototype, "imgList", void 0);
__decorate([
    Prop()
], default_1.prototype, "param", void 0);
__decorate([
    Prop()
], default_1.prototype, "loading", void 0);
__decorate([
    Prop()
], default_1.prototype, "empty", void 0);
__decorate([
    Prop()
], default_1.prototype, "isDate", void 0);
default_1 = __decorate([
    Component({
        name: 'right',
        components: { ResultPage },
        i18n: {
            messages: {
                en: {
                    searchResults: 'Search Results',
                    defaultText: 'please fill in the search criteria first',
                    times: 'Sort by number of companion times from more to less',
                    time: 'Sort by time from near to far',
                    companionTimes: 'Companion Times',
                    last: 'Last',
                    noData: 'No Data',
                },
                zh: {
                    searchResults: '搜索结果',
                    defaultText: '请先补充检索条件',
                    times: '按同行次数由多到少排序',
                    time: '按最新同行时间由近及远排序',
                    companionTimes: '同行次数',
                    last: '最新',
                    noData: '暂无数据',
                },
            },
        },
    })
], default_1);
export default default_1;
